import BundleOptions from "./BundleOptions";
import BundleInfo from "./BundleInfo";

export default function Bundle({ bundleOptions, bundleInfo, locale }) {
  return (
    <>
      <BundleOptions data={bundleOptions || []} locale={locale} />
      <BundleInfo data={bundleInfo || []} locale={locale} />
    </>
  );
}
